import ListPagination from 'common/ListPagination'
import { getParsedQuery } from 'utils/common'
import { useRouter } from 'next/router'
import { PAGINATION_LIMIT } from 'constants/api'
import qs from 'qs'

type ProviderListPaginationProp = {
  providerPagination: PaginationSchema
}

const ProviderListPagination: React.FC<ProviderListPaginationProp> = ({
  providerPagination,
}) => {
  const router = useRouter()
  const { query, pathname } = router
  const { count, offset } = providerPagination

  const pageLimit = parseInt(query?.limit as string) || PAGINATION_LIMIT
  const parsedQuery = getParsedQuery(router)

  const onPageChange = (offset: number) => {
    const queryPath = `${pathname}?${qs.stringify(
      {
        ...parsedQuery,
        offset,
        limit: pageLimit,
      },
      { encode: false, arrayFormat: 'brackets' }
    )}`

    router.push(queryPath, undefined, { shallow: true })
  }

  const onLimitChange = (option: SelectNumberItem) => {
    const queryPath = `${pathname}?${qs.stringify(
      {
        ...parsedQuery,
        limit: option.value,
        offset: 0,
      },
      { encode: false, arrayFormat: 'brackets' }
    )}`

    router.push(queryPath, undefined, { shallow: true })
  }

  if (count <= PAGINATION_LIMIT) {
    return null
  }

  return (
    <div className="d-flex justify-content-center justify-content-md-start w-100 py-3 px-3">
      <ListPagination
        limit={pageLimit}
        count={count}
        offset={offset}
        onNextPage={onPageChange}
        onPreviousPage={onPageChange}
        onPageChange={onPageChange}
        onLimitChange={onLimitChange}
        limitPostfixText="Providers"
      />
    </div>
  )
}

export default ProviderListPagination
